export const V3_API_VERSION = 'v3';

const versionedV3 = (path: string) => `/${V3_API_VERSION}/${path}`;

export const endpointsV3 = {
  agents: versionedV3('agents'),
  analytics: versionedV3('analytics'),
  askAi: versionedV3('ask-ai'),
  avatars: versionedV3('avatars'),
  billing: versionedV3('billing'),
  calls: versionedV3('calls'),
  creator: versionedV3('creator'),
  creatorOrganizationInvites: versionedV3('creator/organization-invites'),
  demoAgentsCatalog: versionedV3('demo/agents-catalog'),
  developerKeys: versionedV3('developer-keys'),
  externalApis: versionedV3('external-apis'),
  feedback: versionedV3('feedback'),
  feedbackStatus: versionedV3('feedback/status'),
  knowledgeFiles: versionedV3('knowledge-files'),
  livekitRooms: versionedV3('livekit-rooms'),
  organization: versionedV3('organization'),
  organizationCreators: versionedV3('organization/creators'),
  organizationInvites: versionedV3('organization/invites'),
  organizationStripePortalUrl: versionedV3('organization/stripe-portal-url'),
  organizationUsage: versionedV3('organization/usage'),
  register: versionedV3('register'),
  videos: versionedV3('videos'),
  webhook: versionedV3('webhook'),
} as const;
